<ng-container *transloco="let t">
    <app-admin-modal-layout
            [title]="'league.competitors.duplicate.modal.title'"
            (onClose)="onClose()"
            (onSave)="onConfirm()"
            [saveDisabled]="!(activeRow !== null && decision)"
    >
        <div class="pb-4">
            @if (duplicates?.length) {

            <!-- Table header -->
            <div class="dup-table-header border-bottom">
                <div (click)="toggleAll()">
                    <span class="expand-all-icon">
                        @if (expandedRows.size) {
            <i class="bi bi-arrows-collapse"></i>
            } @else {
            <i class="bi bi-arrows-expand"></i>
            }
            </span>
        </div>
        <div>{{ t('league.competitors.duplicate.target') }}</div>
                    <div class="text-center">{{ t('league.competitors.duplicate.swap') }}</div>
                    <div>{{ t('league.competitors.duplicate.potential.match') }}</div>
                    <div class="text-center">{{ t('league.competitors.duplicate.matched.fields.count') }}</div>
                    <div class="text-center">{{ t('league.competitors.duplicate.merge') }}</div>
                    <div class="text-center">{{ t('league.competitors.duplicate.keep.separate') }}</div>
                    <div class="text-center">{{ t('league.competitors.duplicate.mark.duplicate') }}</div>
                </div>

                <div class="scrollable">
                    @for (dup of duplicates; track $index) {
            <div class="dup-row" [ngClass]="{'border-bottom': !expandedRows.has($index), 'background-grey-neutral-50': expandedRows.has($index)}">

                <!-- Summary row -->
                <div class="dup-row-summary">
                    <div (click)="toggleCandidate($index)">
                                    <span class="expand-icon" [class.open]="expandedRows.has($index)">
                                        <i class="bi bi-chevron-right"></i>
                                    </span>
                    </div>

                    <div class="d-flex align-items-center gap-2" (click)="toggleCandidate($index)">
                        <div>
                            <div class="fs-14 fw-500">
                                <ng-container *ngTemplateOutlet="competitorName; context: { $implicit: dup.existing }"/>
                            </div>
                            <div class="fs-12 mt-2">ID {{ dup.existing?.id }}</div>
                        </div>
                    </div>

                    <div (click)="swapCompetitors($index)" class="swap-holder text-center">
                        <span class="swap-icon"><i class="bi bi-arrow-left"></i></span>
                    </div>

                    <div (click)="toggleCandidate($index)" [ngClass]="{'duplicate': activeRow === $index && decision === LeagueCompetitorResolveStatus.MARK_DUPLICATE}">
                        <div class="fs-14 fw-500">
                            <ng-container *ngTemplateOutlet="competitorName; context: { $implicit: dup.duplicate }"/>
                        </div>
                        <div class="fs-12 mt-2">ID {{ dup.duplicate?.id }}</div>
                    </div>

                    <div class="text-center" (click)="toggleCandidate($index)">
                                    <span class="match-badge green">
                                        {{ dup.existing?.isTeam ? dup.matchingMembersCount : dup.matchedFields?.length }}
                                    </span>
                    </div>

                    <div class="d-flex justify-content-center">
                        <input type="radio" class="action"
                               [checked]="activeRow === $index && decision === LeagueCompetitorResolveStatus.MERGE"
                               (change)="select($index, LeagueCompetitorResolveStatus.MERGE)"/>
                    </div>
                    <div class="d-flex justify-content-center">
                        <input type="radio" class="action"
                               [checked]="activeRow === $index && decision === LeagueCompetitorResolveStatus.KEEP_SEPARATE"
                               (change)="select($index, LeagueCompetitorResolveStatus.KEEP_SEPARATE)"/>
                    </div>
                    <div class="d-flex justify-content-center">
                        <input type="radio" class="action"
                               [checked]="activeRow === $index && decision === LeagueCompetitorResolveStatus.MARK_DUPLICATE"
                               (change)="select($index, LeagueCompetitorResolveStatus.MARK_DUPLICATE)"/>
                    </div>
                </div>

                <!-- Expanded detail -->
                @if (expandedRows.has($index)) {
                <div class="p-4 background-grey-neutral-50 border-bottom">
                    <div class="detail-grid">

                        <!-- EXISTING -->
                        <div class="detail-col">
                            <div class="detail-col-title">{{ t('league.competitors.duplicate.target') }} - ID {{ dup.existing?.id }}</div>
                                            @if (dup.existing?.isTeam) {
                <ng-container *ngTemplateOutlet="teamDetail; context: { $implicit: dup.existing }"/>
                } @else {
                <ng-container *ngTemplateOutlet="memberCard; context: { $implicit: dup.existing }"/>
                }
                <ng-container *ngTemplateOutlet="racesDetail; context: { $implicit: dup.existing }"/>
                                        </div>

                                        <div class="vertical-divider"></div>

                                        <!-- DUPLICATE -->
                                        <div class="detail-col" [ngClass]="{'duplicate': activeRow === $index && decision === LeagueCompetitorResolveStatus.MARK_DUPLICATE}">
                                            <div class="detail-col-title">{{ t('league.competitors.duplicate.potential.match') }} - ID {{ dup.duplicate?.id }}</div>
                                            @if (dup.duplicate?.isTeam) {
                <ng-container *ngTemplateOutlet="teamDetail; context: { $implicit: dup.duplicate }"/>
                } @else {
                <ng-container *ngTemplateOutlet="memberCard; context: { $implicit: dup.duplicate }"/>
                }
                <ng-container *ngTemplateOutlet="racesDetail; context: { $implicit: dup.duplicate }"/>
                                        </div>
                                    </div>

                                    <!-- matched/not matched fields — individual only -->
                                    @if (!dup.existing?.isTeam) {
                <div class="match-tags">
                    <span class="fs-11">{{ t('league.competitors.duplicate.matched.by') }}:</span>
                    @for (field of dup.matchedFields; track field) {
                    <span class="status-badge green">{{ t('league.competitors.duplicate.matched.by.' + field) }}</span>
                    }
                </div>
                <div class="match-tags">
                    <span class="fs-11">{{ t('league.competitors.duplicate.not.matched.by') }}:</span>
                    @for (field of dup.notMatchedFields; track field) {
                    <span class="status-badge red">{{ t('league.competitors.duplicate.matched.by.' + field) }}</span>
                    }
                </div>
                }

                <!-- team matched members -->
                @if (dup.existing?.isTeam) {
                <ng-container *ngTemplateOutlet="teamMatchedMembers; context: { $implicit: dup }"/>
                }
                </div>
                }
            </div>
            }
            </div>

            } @else {
            <div class="my-3">
                <app-empty-state-admin/>
            </div>
            }
        </div>
    </app-admin-modal-layout>

    <!-- ==================== TEMPLATES ==================== -->

    <!-- Competitor name -->
    <ng-template #competitorName let-competitor>
        {{ competitor?.isTeam ? competitor?.teamName : (competitor?.firstName + ' ' + competitor?.lastName) }}
    </ng-template>

    <!-- Member card (used for both individual and team members) -->
    <ng-template #memberCard let-member>
        <div class="member-card fs-12 py-1">
            <div class="fw-500 fs-13">{{ member?.firstName }} {{ member?.lastName }}</div>
            <div class="d-flex flex-wrap gap-2 mt-1 fs-11 text-muted">
                @if (member?.sex) {
                <span>{{ t('app.common.gender.short.' + member.sex) }}</span>
                }
                @if (member?.birthday) {
                <span>{{ member.birthday | localizedDate:'shortDate' }}</span>
                }
                @if (member?.categoryItemLabel) {
                <span>{{ member.categoryItemLabel }}</span>
                }
                @if (member?.country) {
                <span>{{ member.country | country }}</span>
                }
            </div>
        </div>
    </ng-template>

    <!-- Team detail fields -->
    <ng-template #teamDetail let-competitor>
        <div class="d-flex justify-content-between px-0 py-1 fs-12 border-bottom">
            <span>{{ t('app.common.team.name') }}</span>
            <span class="fw-500">{{ competitor?.teamName }}</span>
        </div>
    </ng-template>

    <!-- Races detail -->
    <ng-template #racesDetail let-competitor>
        <div class="d-flex justify-content-between px-0 py-1 fs-12">
            <span>{{ t('app.common.races') }}</span>
            <div class="d-flex flex-column text-end">
                @if (competitor?.rounds?.length) {
                @for (race of competitor!.rounds; track race.id!) {
                <div class="d-flex">
                    <span class="pe-2">{{ race.id }}</span>
                    <span class="pe-2">-</span>
                    <span class="fw-500">{{ raceNames.get(race.id!) }}</span>
                </div>
                }
                } @else {
                <span class="fw-500">-</span>
                }
            </div>
        </div>
    </ng-template>

    <!-- Team matched members side by side -->
    <ng-template #teamMatchedMembers let-dup>
        @let unmatchedExisting = getUnmatchedMembers(dup, true);
        @let unmatchedDuplicate = getUnmatchedMembers(dup, false);

        <div class="team-members-comparison mt-3">
            <div class="team-members-sides">

                <!-- EXISTING SIDE -->
                <div class="team-members-side">
                    <div class="detail-col-title mb-2">{{ dup.existing?.teamName }}</div>

                    @for (pair of dup.matchedMembers; track $index) {
                    <div class="matched-member py-2" [class.member-separator]="!$last || unmatchedExisting?.length">
                        <ng-container *ngTemplateOutlet="memberCard; context: { $implicit: pair.memberFromExisting }"/>
                            <div class="field-diff-badges mt-2">
                                @for (field of pair.matchedFields; track field) {
                                    <span class="status-badge green fs-10">{{ t('league.competitors.duplicate.matched.by.' + field) }}</span>
                                }
                                @for (field of pair.notMatchedFields; track field) {
                                    <span class="status-badge red fs-10">{{ t('league.competitors.duplicate.matched.by.' + field) }}</span>
                                }
                            </div>
                    </div>
                    }

                    @if (unmatchedExisting?.length) {
                    <div class="unmatched-divider my-2">
                        <span class="fs-11 text-muted">{{ t('league.competitors.duplicate.not.matching') }}</span>
                        </div>
                        @for (member of unmatchedExisting; track member.id) {
                    <div class="unmatched-member py-2" [class.member-separator]="!$last">
                        <ng-container *ngTemplateOutlet="memberCard; context: { $implicit: member }"/>
                    </div>
                    }
                    }
                </div>

                <div class="vertical-divider"></div>

                <!-- DUPLICATE SIDE -->
                <div class="team-members-side">
                    <div class="detail-col-title mb-2">{{ dup.duplicate?.teamName }}</div>

                    @for (pair of dup.matchedMembers; track $index) {
                    <div class="matched-member py-2" [class.member-separator]="!$last || unmatchedDuplicate?.length">
                        <ng-container *ngTemplateOutlet="memberCard; context: { $implicit: pair.memberFromDuplicate }"/>
                            <div class="field-diff-badges mt-2">
                                @for (field of pair.matchedFields; track field) {
                    <span class="status-badge green fs-10">{{ t('league.competitors.duplicate.matched.by.' + field) }}</span>
                    }
                    @for (field of pair.notMatchedFields; track field) {
                    <span class="status-badge red fs-10">{{ t('league.competitors.duplicate.matched.by.' + field) }}</span>
                    }
                    </div>
                </div>
                    }

                    @if (unmatchedDuplicate?.length) {
                    <div class="unmatched-divider my-2">
                        <span class="fs-11 text-muted">{{ t('league.competitors.duplicate.not.matching') }}</span>
                        </div>
                        @for (member of unmatchedDuplicate; track member.id) {
                    <div class="unmatched-member py-2" [class.member-separator]="!$last">
                        <ng-container *ngTemplateOutlet="memberCard; context: { $implicit: member }"/>
                    </div>
                    }
                    }
                </div>
            </div>
        </div>
    </ng-template>

</ng-container>